import React from "react";
import { Provider } from "react-redux";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { Routes } from "./routes";
import { I18nProvider } from "./Lang/i18n";
import { MaterialThemeProvider } from "./Layout/metronicLayout";

function App({ store }) {
  return (
    <Provider store={store}>
      <MaterialThemeProvider>
        <I18nProvider>
          {/* <ToastContainer /> */}
          <Routes />
        </I18nProvider>
      </MaterialThemeProvider>
    </Provider>
  );
}

export default App;
